module.exports = __webpack_public_path__ + "images/emoji/boom.70e6c999a34014795354.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/boom.png
// module id = Ar4Q
// module chunks = 14